/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="1110" height="195" {...props}>
    <circle cx="42" cy="136" r="11" fill="#05F"></circle>
    <circle cx="98" cy="79" r="11" fill="#05F"></circle>
    <circle cx="194" cy="149" r="11" fill="#05F"></circle>
    <circle cx="378" cy="79" r="11" fill="#05F"></circle>
    <circle cx="484" cy="147" r="11" fill="#05F"></circle>
    <circle cx="577" cy="79" r="11" fill="#05F"></circle>
    <circle cx="263" cy="68" r="11" fill="#05F"></circle>
    <circle cx="179" cy="79" r="11" fill="#05F"></circle>
    <circle cx="115" cy="149" r="11" fill="#05F"></circle>
    <circle cx="285" cy="127" r="11" fill="#05F"></circle>
    <circle cx="473" cy="46" r="11" fill="#05F"></circle>
    <circle cx="378" cy="158" r="11" fill="#05F"></circle>
    <circle cx="703" cy="65" r="11" fill="#05F"></circle>
    <circle cx="641" cy="158" r="11" fill="#05F"></circle>
    <circle cx="851" cy="76" r="11" fill="#05F"></circle>
    <circle cx="946" cy="158" r="11" fill="#05F"></circle>
    <circle cx="999" cy="58" r="11" fill="#05F"></circle>
    <circle cx="935" cy="105" r="11" fill="#05F"></circle>
    <circle cx="851" cy="149" r="11" fill="#05F"></circle>
    <circle cx="756" cy="127" r="11" fill="#05F"></circle>
    <circle cx="520" cy="102" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="420" cy="116" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="325" cy="76" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="223" cy="109" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="137" cy="127" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="134" cy="54" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="54" cy="58" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="87" cy="120" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="67" cy="162" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="164" cy="169" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="252" cy="162" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="175" cy="116" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="210" cy="54" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="179" cy="35" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="263" cy="32" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="336" cy="32" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="305" cy="162" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="336" cy="125" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="431" cy="160" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="420" cy="68" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="381" cy="43" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="529" cy="35" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="464" cy="91" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="531" cy="147" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="581" cy="160" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="566" cy="110" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="630" cy="110" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="621" cy="46" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="570" cy="46" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="672" cy="38" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="676" cy="94" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="692" cy="142" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="747" cy="158" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="747" cy="90" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="761" cy="60" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="722" cy="32" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="812" cy="39" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="801" cy="87" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="873" cy="121" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="914" cy="58" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="988" cy="98" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="1047" cy="103" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="1015" cy="149" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="1056" cy="32" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="898" cy="158" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="795" cy="143" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="865" cy="32" r="9" stroke="#05F" strokeWidth="4"></circle>
    <circle cx="954" cy="38" r="9" stroke="#05F" strokeWidth="4"></circle>
    <rect
      width="1103"
      height="188"
      x="3.5"
      y="3.5"
      stroke="#05F"
      strokeWidth="7"
      rx="16.5"
    ></rect>
  </Svg>
)

export default Icon
